<template>
  <a :href="'https://www.twitch.tv/' + channelName" v-bind:class="{ online: streamStatus === 'ONLINE', offline: streamStatus !== 'ONLINE' }" class="link-btn" :aria-label="'external link: stream is currently ' + streamStatus" :title="'Twitch.tv/' + channelName">{{streamStatus}}</a>
</template>

<script>
import TwitchGateway from '../../gateways/twitch.js'
export default {
  name: 'stream-status',
  props: ['channelId', 'channelName'],
  data () {
    return {
      streamStatus: 'OFFLINE'
    }
  },
  mounted () {
    TwitchGateway.isStreamLive(this.channelName).then(function (results) {
      if (results.body.data !== null && results.body.data.length > 0) {
        this.streamStatus = 'ONLINE'
      }
    }.bind(this))
  }
}
</script>

<style scoped lang="scss">
@import '../../variables.scss';
.stream-status{
  margin: 9px 0;
}
a{
  border: 2px solid #767676;
  border-radius: 25px;
  &.online{
    border: 2px solid $stream-online;
    &:hover, &:focus{
      background-color: $stream-online !important;
    }
  }
  &.offline {
    border: 2px solid $stream-offline;
    &:hover, &:focus{
      background-color: $stream-offline !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// StreamStatus.vue?d2d27b8a